/* eslint-disable no-bitwise */
import generateGameUrl from '../utils/generateGameUrl';

import useGameUrlPayload from './useGameUrlPayload';

interface FlagsProps {
  isFlash?: boolean;
  isMax?: boolean;
}

export type Payload = FlagsProps & { scriptId: number };

enum SpinFlag {
  PROMOTIONAL = 1 << 0, // Whether this is a promotional spin & go
  FIXED = 1 << 1, // Whether this is a fixed-payout spin & go
  MAX = 1 << 2, // Whether this is a spin & go max, with a variable number of entrants and prize draw
  FLASH = 1 << 3 // Whether this is a spin & go flash, with faster game-play
}

export const getFlag = ({ isFlash, isMax }: FlagsProps): number => {
  if (isFlash) return SpinFlag.FLASH;
  if (isMax) return SpinFlag.MAX;

  return SpinFlag.FIXED;
};

const useSAGGameUrl = ({ isFlash, isMax, scriptId }: Payload) => {
  const { resolver, ...payload } = useGameUrlPayload();

  const urlConfig = {
    ...payload,
    gametype: 'spin',
    flags: getFlag({ isFlash, isMax }),
    scriptId
  };

  return generateGameUrl(urlConfig, resolver);
};

export default useSAGGameUrl;
